import { Component, OnInit, HostListener } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { DecodeTicketService } from '../../shared/services/decode-ticket.service';
import { KeyboardServiceService } from '../../shared/keyboard-service/keyboard-service.service';
import { ValidationService } from '../../shared/services/validation.service';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  showSpinner: boolean = false;
  loginInvalid: boolean = false;
  showError: boolean = false;
  errorMessage: String = '';
  signInArray = ['email', 'password'];
  signin = {
    email: '',
    password: ''
  }

  constructor(
    private keyboardSvc: KeyboardServiceService,
    private dataSvc: DatabusService,
    private validate: ValidationService,
    private idle: Idle,
    private router: Router
  ) {
    if(this.dataSvc.currentEmail) {
      this.signin.email = this.dataSvc.currentEmail
    }
   }

   SetModelFromKeyboard (val) {
    let currentModel = this.keyboardSvc.getCurrentModel();
    if(val === 'DELETE') {
      this.signin[currentModel] = this.keyboardSvc.deleteValue(this.signin[currentModel]);
    } else {
      this.signin[currentModel] = this.signin[currentModel] + val;
    }
  }

  TabToNextField (val) {
    let currentIdx = this.signInArray.indexOf(this.keyboardSvc.currentModel);
    if(val === 'NEXT' && currentIdx !== this.signInArray.length - 1) {
      this.keyboardSvc.currentModel = this.signInArray[currentIdx + 1]
    } else if(currentIdx !== 0) {
      this.keyboardSvc.currentModel = this.signInArray[currentIdx - 1]
    }
  }

  isCurrent (name) {
    return this.keyboardSvc.currentModel === name;
  }

  Cancel () {
    this.router.navigate(['/scanticket']);
  }

  CloseError() {
    this.showError = false;
  }

  Register() {
    this.dataSvc.forceRegistration = true;
    this.router.navigate(['/addprofile']);
  }

  Login() {
    this.showSpinner = true;
    let login = {
      email: this.signin.email,
      password: this.signin.password
    }
    this.validate.accountLogin(login)
    .then((results) => {
      console.log(results)
      var status = parseInt(results.status);
      if(status >= 400) {
        this.showSpinner = false;
        this.errorMessage = results.message;
        this.showError = true;
      } else {
        this.dataSvc.currentLogin = results;
        this.dataSvc.currentEmail = this.signin.email;
        this.dataSvc.password = this.signin.password;
        if(this.dataSvc.currentClubCard) {
          this.AssignClubCard();
        } else {
          this.AssignTicket();
        }    
      }      
    })
    .catch((err) => {
      this.showSpinner = false;
      this.errorMessage = "There was a problem logging into your account.";
      this.loginInvalid = true;
      console.log(err)
    });   
  }


  AssignClubCard () {
    let assign = {
      email: this.signin.email,
      cardCode: this.dataSvc.currentClubCard
    }
    this.validate.assignCardCode(assign)
    .then((results) => {
      if(results.status === "201") {
        if(this.dataSvc.currentTicket) {
          this.AssignTicket();
        } else {
          this.router.navigate(['/scananother']);
        }        
      }
    })
  }

  AssignTicket() {
    let ticket = {
      email: this.dataSvc.currentEmail,
      code: this.dataSvc.currentTicket.code
    }
    this.validate.assignTicketAccount(ticket)
    .then((results) => {
      if(results.status === "204") {
        this.dataSvc.redeemValue = results.value;
        this.router.navigate(['/success']);
      }
      if(results.status === "409") {
        this.dataSvc.errorMessage = results.message;
        this.router.navigate(['/invalid']);
      }
    })
  }

  ngOnInit() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/login/login.component.ts